import { _Sha1 } from '../encryptors/secureHash-algorithm1';
var _PdfSubjectKeyIdentifier = /** @class */ (function () {
    function _PdfSubjectKeyIdentifier(info) {
        this._bytes = this._generateKeyID(info);
    }
    _PdfSubjectKeyIdentifier.prototype._generateKeyID = function (info) {
        var sha1 = new _Sha1();
        var publicKeyBytes = info._publicKey._data;
        return sha1._hash(publicKeyBytes, 0, publicKeyBytes.length);
    };
    return _PdfSubjectKeyIdentifier;
}());
export { _PdfSubjectKeyIdentifier };
